// Optimisation LCP des pages prerendues (SEO technique, oct. 2026).
//
// Quand une page est servie depuis un snapshot statique (#root déjà rempli) :
//  1) consumeInstantPaint(path) → true UNE SEULE FOIS pour la page du chargement
//     initial : les animations d'entrée du premier écran sont sautées (le contenu
//     est déjà peint par le HTML statique — rejouer un fade-in le ferait
//     disparaître puis réapparaître, ce qui retarde le LCP mesuré).
//     Les navigations SPA suivantes gardent toutes leurs animations.
//  2) bootData(apiPath) → données API embarquées dans le snapshot par
//     scripts/prerender_snapshots.py (window.__BOOT_DATA__) : le montage React
//     rend immédiatement le contenu final au lieu d'un squelette de chargement.
//     Les pages re-fetchent ensuite en arrière-plan (stale-while-revalidate),
//     la fraîcheur du contenu reste donc garantie par l'API.

const hadStaticContent =
  typeof document !== "undefined" && !!document.getElementById("root")?.firstElementChild;

const cleanPath = (p) => (p || "/").replace(/\/+$/, "") || "/";

let pendingPath = hadStaticContent ? cleanPath(window.location.pathname) : null;

export const consumeInstantPaint = (pathname) => {
  if (pendingPath === null || pendingPath !== cleanPath(pathname)) return false;
  pendingPath = null;
  return true;
};

export const bootData = (apiPath) => {
  const store = typeof window !== "undefined" ? window.__BOOT_DATA__ : null;
  return store ? store[apiPath] : undefined;
};
